// Page and event hooks. KarbonKit uses no analytics service (/privacy says
// so), so these do nothing unless a gtag is on the page, and none is: the
// Google Analytics loader that used to live here was removed on 2026-10-02.

export function trackPageView(path) {
  if (!window.gtag) return;
  window.gtag('event', 'page_view', { page_path: path });
}

export function trackEvent(name, params = {}) {
  if (!window.gtag) return;
  window.gtag('event', name, params);
}
